import React, { useEffect } from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";
import { Auth } from "shared/@auth/Auth";
import Page, { Content, Nav, NavGroup, NavItem } from "shared/Page";
import {
  IconAlert,
  IconCalendar,
  IconDelete,
  IconMajorFunction,
} from "@wwg/icons";

import { useCurrentRoute } from "shared/@hooks/useCurrentRoute.js";

import { CalendarPage } from "./CalendarPage/CalendarPage.jsx";
import { IncidentsPage } from "./IncidentsPage/IncidentsPage.jsx";
import { IncidentPage } from "./IncidentsPage/IncidentPage/IncidentPage.jsx";
import { ExportReportPage } from "./IncidentsPage/ExportReportPage/ExportReportPage.jsx";
import { EscalationsPage } from "./EscalationsPage/EscalationsPage.jsx";
import { EventsPage } from "./EventsPage/EventsPage.jsx";
import { EventsDetailsPage } from "./EventsPage/EventsDetails/EventsDetailsPage.jsx";
import { IBOFilePage } from "./IBOFilePage/IBOFilePage.jsx";

export function Security() {
  const { path } = useRouteMatch();
  const { hasPermission } = Auth.useContainer();
  const { setCurrentRoute } = useCurrentRoute();

  useEffect(() => {
    setCurrentRoute("/security");
    return () => {
      setCurrentRoute("");
    };
  });

  return (
    <Page>
      <Nav>
        <NavGroup title="Security Portal">
          {hasPermission("developer.*") && (
            <NavItem to={`${path}/incidents`} icon={<IconAlert />}>
              Incidents
            </NavItem>
          )}

          {hasPermission("developer.*") && (
            <NavItem to={`${path}/escalations`} icon={<IconDelete />}>
              Escalations
            </NavItem>
          )}

          {hasPermission("developer.*") && (
            <NavItem to={`${path}/events`} icon={<IconMajorFunction />}>
              Events
            </NavItem>
          )}

          {hasPermission("developer.*") && (
            <NavItem to={`${path}/calendar`} icon={<IconCalendar />}>
              Calendar
            </NavItem>
          )}
        </NavGroup>
      </Nav>
      <Content>
        <Switch>
          {hasPermission("developer.*") && (
            <Route path={`${path}/incidents`}>
              <IncidentsPage />
            </Route>
          )}

          {hasPermission("developer.*") && (
            <Route path={`${path}/incident/:incidentNumber`}>
              <IncidentPage />
            </Route>
          )}

          {hasPermission("developer.*") && (
            <Route path={`${path}/report/:incidentNumber`}>
              <ExportReportPage />
            </Route>
          )}

          {hasPermission("developer.*") && (
            <Route path={`${path}/escalations`}>
              <EscalationsPage />
            </Route>
          )}

          {hasPermission("developer.*") && (
            <Route path={`${path}/events`}>
              <EventsPage />
            </Route>
          )}

          {hasPermission("developer.*") && (
            <Route path={`${path}/event/:eventId`}>
              <EventsDetailsPage />
            </Route>
          )}

          {hasPermission("developer.*") && (
            <Route path={`${path}/calendar`}>
              <CalendarPage />
            </Route>
          )}

          {hasPermission("developer.*") && (
            <Route path={`${path}/ibo/:id`}>
              <IBOFilePage />
            </Route>
          )}

          <Route path="*">
            <Redirect to={`${path}/incidents/`} />
          </Route>
        </Switch>
      </Content>
    </Page>
  );
}
